module.exports = __webpack_public_path__ + "img/centered-fish.b6c95c52.svg";